export default __webpack_public_path__ + "static/hero-18982e54533369eb0dc4d2be5e80332f.jpg";